import axios from 'axios';
import { DkpLocationModel, RpjLocationModel } from 'app/edozvola/cases/case-location/model/case-location.model';

export const getLocationDataSource = async (caseUuid: string): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/${caseUuid}/location-data-source`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const saveRpjLocation = async (idCase: string, rpjLocation: RpjLocationModel): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/cases/${idCase}/rpj-locations`, rpjLocation)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const fetchRpjLocations = async (idCase: string, page: number, size: number, column: string, direction: string): Promise<any> => {
  if (idCase) {
    return await new Promise(resolve => {
      axios
        .get(`api/cases/${idCase}/rpj-locations?page=${page}&size=${size}&column=${column}&direction=${direction}`)
        .then(response => resolve(response.data));
    });
  }
};

export const getRpjLocation = async (idRpjLocation: string): Promise<RpjLocationModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/uuid/rpj-locations/${idRpjLocation}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const deleteRpjLocation = async (idRpjLocation: number): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .delete(`api/cases/uuid/rpj-locations/${idRpjLocation}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const saveDkpLocation = async (idCase: string, dkpLocation: DkpLocationModel): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/cases/${idCase}/dkp-locations`, dkpLocation)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const fetchDkpLocations = async (idCase: string, page: number, size: number, column: string, direction: string): Promise<any> => {
  if (idCase) {
    return await new Promise(resolve => {
      axios
        .get(`api/cases/${idCase}/dkp-locations?page=${page}&size=${size}&column=${column}&direction=${direction}`)
        .then(response => resolve(response.data));
    });
  }
};

export const getDkpLocation = async (idDkpLocation: string): Promise<DkpLocationModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/uuid/dkp-locations/${idDkpLocation}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const deleteDkpLocation = async (idDkpLocation: number): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .delete(`api/cases/uuid/dkp-locations/${idDkpLocation}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const fetchIspuLocation = async (caseUuid: string): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/cases/${caseUuid}/fetch-ispu-location`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};
